/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, memo } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { getCardsData } from 'store/customer/customer-view-actions';
import Tile from 'components/shared/tiles/Tile';
import classes from './TileContainer.module.scss';

const TileContainer = memo(({ page }) => {
  const dispatch = useDispatch();
  const cards = useSelector((state) => state?.CustomerView?.cards);
  const selectedInsightView = useSelector(
    (state) => state?.CustomerView?.selectedInsightView
  );
  const insightType = useSelector((state) => state?.CustomerView?.insightType);

  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );
  useEffect(() => {
    if (allInsightViews?.length > 0)
      dispatch(getCardsData(insightType, selectedInsightView?.Id));
  }, [selectedInsightView?.Id, allInsightViews?.length]);

  const ListElement = ({ item: card, area }) => {
    return (
      <Col
        sm={4}
        md={4}>
        <Tile
          card={card}
          page={page}
          area={area}
        />
      </Col>
    );
  };

  return (
    <div className='tile-container'>
      {cards?.length > 0 && (
        <div
          md={12}
          className={classes['tile-container-drag-drop-container']}>
          <Row className='list-manager-insights g-3'>
            {cards?.map((item, index) => (
              <ListElement
                key={item.cardId}
                item={item}
                area={item.cardId}
              />
            ))}
          </Row>
        </div>
      )}
    </div>
  );
});

export default TileContainer;
